module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraBold.19ba7aa5.ttf";